import { http } from "../http";

export async function fetchDeliverectChannelLinks(): Promise<
  Array<IFetchDeliverectChannelLink>
> {
  const response = await http.get("/api/v3/deliverect/channel-links");

  return response.data.data.map((obj: any) => ({
    outletId: obj.outlet_id,
    businessId: obj.business_id,
    channelLinkId: obj.channel_link_id,
  }));
}

export interface IFetchDeliverectChannelLink {
  outletId: "";
  businessId: "";
  channelLinkId: "";
}
